import { ONE_SECOND_IN_MS } from "@/constants/Time";
import {createFormattedParams, updateUrlWithQueryParams} from "@/helpers/queryParamsHelper";
import { emitter } from "@/plugins/emitter";
import search from "@/services/api/VehicleServiceApi";
import testStorage from "@/services/localStorage";
import router from "@/plugins/router";
import { FUEL_TYPES, PURCHASE_METHODS, REPORT_STATUSES, TRANSMISSION_TYPES, VEHICLE_CONDITIONS, VEHICLE_TYPES } from "@/constants/FilterOptions";
import searchFilters from "@/services/api/FilterServiceApi";
import getAllAdvertiserType from "@/services/api/FiltersServiceApi";

const DEFAULT_STATE = {
  loading: true,
  vehicleLoading: true,
  vehiclesFilterLoading: false,
  selectedEntity: "",
  loadingCampaign: {},
  listVeiculos: [],
  advertiserTypes: [],
  cacheLoaded: false,
  request: null,
  mobile: false,
  result: [],
  resultVehicleIds: [],
  filters: [],
  ignoreFilters: [
    {
      field: 'reportStatus',
      label: 'laudo',
    },
    {
      field: 'fuel',
      label: 'combustiveis',
    },
    {
      field: 'transmission',
      label: 'transmissoes',
    },
  ],
  aliasFilter: {
    quotation: "modalidade",
    vehicleCondition: "condicao",
    typeVehicle: "tipo",
    reportStatus: "laudo",
    optionals: "opcionais",
    fuel: "combustiveis",
    transmission: "transmissoes",
  },
  params: {},
  fipe: 0,
  priceMin: undefined,
  priceMax: undefined,
  yearMin: undefined,
  yearMax: undefined,
  kmMin: undefined,
  kmMax: undefined,
  campaign: undefined,
  page: 1,
  perPage: 0,
  total: 0,
  totalResults: 0,
  totalOfResult: 0,
  orderBy: "",
  optionalsData: {
    optionals: [],
    fuel: [],
    transmission: [],
    brands: [],
    filteredBrands: [],
  },
  triggerResize: false,
  refreshSearchFilter: true,
};

const fieldMap = {
  adType: "tipoAnunciante",
  brands: "marca",
  cities: "cidades",
  fipe: "fipe",
  fuel: "combustivel",
  kmMax: "kmMaximo",
  kmMin: "kmMinimo",
  location: "localidade",
  optionals: "opcionais",
  campaign: "campaign",
  order: "ordenacao",
  priceMax: "valorMaximo",
  priceMin: "valorMinimo",
  quotation: "modalidadeCompra",
  reportStatus: "laudo",
  transmission: "transmissao",
  typeVehicle: "tipo",
  vehicleCondition: "condicao",
  category: "categoria",
  yearMax: "anoMaximo",
  yearMin: "anoMinimo",
  models: "modelo",
  versions: "versao",
};

const filterFormModule = {
  namespaced: true,
  state() {
    return DEFAULT_STATE;
  },
  mutations: {
    setResult(state, result) {
      state.result = result;
      state.resultVehicleIds = result.map(r => r.id_avaliacao);
    },
    setFilters(state, filters) {

      state.filters = filters || {};

      if (Object.keys(state.filters)?.length > 0) {

        const ignored = new Set(state.ignoreFilters.map(i => i.label));

        const filteredFilters = Object.fromEntries(
          Object.entries(filters).filter(([key]) => !ignored.has(key))
        );

        state.filters = filteredFilters || {};
      }
      else {
        state.filters = filters || {};
      }

      state.optionalsData.filteredBrands = filters?.marcas || {};
      state.optionalsData.brands = filters?.marcas ? Object.keys(filters.marcas).map(m => ({ id: m, name: m })) : [];
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setFilterLoading(state, loading) {
      state.vehiclesFilterLoading = loading;
    },
    setRefreshSearchFilter(state, refresh) {
      state.refreshSearchFilter = refresh;
    },
    setVehicleLoading(state, loading) {
      state.vehicleLoading = loading;
    },
    setSelectedEntity(state, entity) {
      if (state.selectedEntity !== entity) {
        state.selectedEntity = entity;
      }
    },
    setLoadingCampaign(state, { campaign, loading }) {
        if (!state.loadingCampaign) {
            state.loadingCampaign = {};
        }
        state.loadingCampaign = {
            ...state.loadingCampaign,
            [campaign]: loading
        };
    },
    setListVeiculo(state, { campaign, data }) {
      if (!state.listVeiculos) state.listVeiculos = {};
      if (!state.listVeiculos[campaign]) {
        state.listVeiculos[campaign] = { carousel: {}, vehicles: [] };
      }

      state.listVeiculos[campaign] = {
        ...state.listVeiculos[campaign],
        vehicles: data
      };
    },
    initCarousel(state, { campaign, carousel }) {
      if (!state.listVeiculos) state.listVeiculos = {};
      state.listVeiculos[campaign] = {
        carousel,
        vehicles: []
      };
    },
    setCategories(state, categories) {
      state.categories = categories;
      this.commit("filterForm/refreshSearch");
    },
    setFipeValue(state, fipe) {
      state.fipe = fipe;
      state.params["fipe"] = fipe;
      state.page = 1;
    },
    setFipe(state, fipe) {
      state.fipe = fipe;
      state.params["fipe"] = fipe;
      state.page = 1;
      this.commit("filterForm/refreshSearch");
    },
    setPriceMin(state, priceMin) {
      state.priceMin = priceMin;
      state.params.priceMin = priceMin;
      state.page = 1;
      this.commit("filterForm/refreshSearch");
    },
    setPriceMax(state, priceMax) {
      state.priceMax = priceMax;
      state.params.priceMax = priceMax;
      state.page = 1;
      this.commit("filterForm/refreshSearch");
    },
    setYearMin(state, yearMin) {
      state.yearMin = yearMin;
      state.params.yearMin = yearMin;
      state.page = 1;
      this.commit("filterForm/refreshSearch");
    },
    setYearMax(state, yearMax) {
      state.yearMax = yearMax;
      state.params.yearMax = yearMax;
      state.page = 1;
      this.commit("filterForm/refreshSearch");
    },
    setKmMin(state, kmMin) {
      state.kmMin = kmMin;
      state.params.kmMin = kmMin;
      state.page = 1;
      this.commit("filterForm/refreshSearch");
    },
    setKmMax(state, kmMax) {
      state.kmMax = kmMax;
      state.params.kmMax = kmMax;
      state.page = 1;
      this.commit("filterForm/refreshSearch");
    },
    setMobile(state) {
      state.mobile = document.body.clientWidth < 1024;
    },
    setOrder(state, orderBy) {
      state.orderBy = orderBy;
      state.params.order = orderBy;
      state.page = 1;
      this.commit("filterForm/refreshSearch");
    },
    setPage(state, page) {
      state.page = page;
    },
    setPerPage(state, perPage) {
      state.perPage = perPage;
    },
    setParam(state, param) {
      this.commit("filterForm/setRefreshSearchFilter", true);
      this.commit("filterForm/setVehicleLoading", true);
      this.commit("filterForm/setFilterLoading", true);

      let key = Object.keys(param)[0];
      let value = Object.is(Object.values(param)[0], {})
        ? Object.values(param)
        : Object.values(param)[0];
      state.params[key] = value;

      this.commit("filterForm/setPage", 1);
      this.commit("filterForm/refreshSearch");
    },
    updateParams(state, params) {
      this.commit("filterForm/setRefreshSearchFilter", true);
      this.commit("filterForm/setVehicleLoading", true);
      this.commit("filterForm/setFilterLoading", true);

      state.params = params;

      this.commit("filterForm/setPage", 1);
      this.commit("filterForm/refreshSearch");
    },
    updateParamsWithoutRefresh(state, params) {
      state.params = params;
    },
    updateReportStatus(_, reportStatus) {
      this.commit("filterForm/setRefreshSearchFilter", true);
      const anotherReportStatusWasSelected = reportStatus.filter(
        (item) => item.id !== "no"
      );
      const lastReportStatus = reportStatus[reportStatus.length - 1];
      const noReportIsSelectedNow = lastReportStatus?.id === "no";

      if (noReportIsSelectedNow) {
        this.commit("filterForm/setParam", {
          reportStatus: [lastReportStatus],
        });
        return;
      }
      if (anotherReportStatusWasSelected) {
        this.commit("filterForm/setParam", {
          reportStatus: anotherReportStatusWasSelected,
        });
        return;
      }
      setTimeout(() => {
        this.commit("filterForm/setParam", { reportStatus });
        this.commit("filterForm/refreshSearch");
      }, ONE_SECOND_IN_MS * 3);
    },
    refreshSearch(state, isSync = false) {
      this.commit("filterForm/setVehicleLoading", true);
      emitter.emit("setParam");
      state.loading = true;
      if (state.request !== null) {
        clearTimeout(state.request);
        state.request = null;
      }

      this.commit("filterForm/objectToQueryParams");

      const cities = state.params["cities"]
        ? state.params["cities"].map((city) => {
            const breakPoint = city.indexOf("-");
            return city.slice(0, breakPoint - 1);
          })
        : null;

      const params = {
      ...state.params,
        cities,
        fipe: state.fipe,
        priceMin: state.priceMin?.toString(),
        priceMax: state.priceMax?.toString(),
        yearMin: state.yearMin?.toString(),
        yearMax: state.yearMax?.toString(),
        kmMin: state.kmMin?.toString(),
        kmMax: state.kmMax?.toString(),
        p: state.page?.toString() ?? 0,
        order: state.orderBy?.toString(),
      }

      state.request = setTimeout(
        async () =>
          await Promise.all([
            this.dispatch("filterForm/search", params),
            this.dispatch("filterForm/searchFilters", params),
          ]),
        isSync ? 0 : ONE_SECOND_IN_MS * 0.8
      );
    },
    objectToQueryParams(state) {
      updateUrlWithQueryParams(state, fieldMap, router.currentRoute.value.name);
    },
    removeParam(state, param) {
      this.commit("filterForm/setRefreshSearchFilter", true);
      this.commit("filterForm/setVehicleLoading", true);
      switch (param) {
        case "fipe":
          delete state.params[param];
          this.commit("filterForm/setFipe", 0);
          break;

        case "order":
          state.order = null;
          state.orderBy = null;
          break;

        default:
          state.params[param] = [];
          break;
      }
      this.commit("filterForm/refreshSearch");
    },
    clear(state, refreshSearch = true) {
      this.commit("filterForm/setRefreshSearchFilter", true);
      if (refreshSearch) {
        this.commit("filterForm/setVehicleLoading", true);
      }
      state.fipe = 0;
      state.request = null;
      state.result = [];
      state.priceMax = undefined;
      state.priceMin = undefined;
      state.yearMin = undefined;
      state.yearMax = undefined;
      state.kmMin = undefined;
      state.kmMax = undefined;
      state.query = "";
      state.page = 1;
      state.perPage = 0;
      state.total = 0;
      state.totalOfResult = 0;
      state.totalResults = 0;
      state.orderBy = "";

      Object.keys(state.params).forEach((param) => {
        this.commit("filterForm/removeParam", param);
      });
      if (refreshSearch) {
        this.commit("filterForm/refreshSearch");
      }
    },
    setParamsObject(state, params) {
      delete params["p"];
      Object.keys(params).forEach((param) => {
        if (param == 'adType' && state.params?.adType?.length > 0) {
          return;
        }
        if (params[param] && params[param].length <= 0) {
          return;
        }
        state.params[param] = params[param];
      });
    },
    setCacheLoaded(state) {
      state.cacheLoaded = true;
    },
    setTotal(state, total) {
      state.total = total;
    },
    setTotalOfResult(state, totalOfResult) {
      state.totalOfResult = totalOfResult;
    },
    setTotalResults(state, totalResults) {
      state.totalResults = totalResults;
    },
    triggerResize(state) {
      state.triggerResize = !state.triggerResize;
    },
  },
  actions: {
    async normalizeParams({ commit }, params) {
      const optionsMap = {
        quotation: PURCHASE_METHODS,
        typeVehicle: VEHICLE_TYPES,
        vehicleCondition: VEHICLE_CONDITIONS,
        reportStatus: REPORT_STATUSES,
        fuel: FUEL_TYPES,
        transmission: TRANSMISSION_TYPES
      };

      const paramsToNormalize = Object.keys(params)
        .filter((key) => optionsMap[key] && params[key]);

      if (paramsToNormalize.length === 0) return;

      const normalizedUpdates = paramsToNormalize.reduce((acc, key) => {
        const value = params[key];
        const normalizer = val =>
          optionsMap[key].find(opt =>
            [opt.id, opt.filter, opt.title].includes(val?.toString())
          ) || val;

        acc[key] = Array.isArray(value)
          ? value.map(normalizer).filter(Boolean)
          : normalizer(value);

        return acc;
      }, {});

      // Atualiza o store
      commit('setParamsObject', normalizedUpdates);

      return normalizedUpdates;
    },
    loadFromCache({ commit, state }) {
      if (state.cacheLoaded) return;
      if (!testStorage()) return;
      const data = localStorage.getItem("paramsFilter");
      let params = typeof data == "string" ? JSON.parse(data) : false;
      if (!params) {
        localStorage.removeItem("paramsFilter");
        return;
      }
      if (state.cacheLoaded == false) commit("setCacheLoaded", true);
      commit("setParamsObject", params);
    },
    async searchCampaignVehicles({ rootState, commit }, params) {
      for (let i = 0; i < params.length; i += 4) {
        const batch = params.slice(i, i + 4);

        await Promise.allSettled(
            batch.map(async (el) => {
              try {
                commit("setLoadingCampaign", { campaign: el, loading: true });

                const userData = rootState.filterShowcase.userData;
                const result = await search({ slug: el, userData });

                if (result) {
                  commit("setListVeiculo", {
                    campaign: el,
                    data: result.result
                  });
                }
              } finally {
                commit("setLoadingCampaign", { campaign: el, loading: false });
              }
            })
        );
      }
    },
    async search({ commit, state, dispatch, rootState }, params) {

      commit("setVehicleLoading", true);

      const paramsFormatted = await createFormattedParams(
        rootState,
        state,
        commit,
        dispatch,
        fieldMap,
        params,
      )

      search(paramsFormatted)
        .then((response) => {
          commit(
            "setResult",
            response.page > 1
              ? [...state.result, ...response.result]
              : response.result ?? []
          );
          commit("setPage", response.page);
          commit("setPerPage", response.perPage);
          commit("setTotal", response.totalPages);
          commit("setTotalOfResult", response.total);
          commit("setTotalResults", response.totalResults);

          if (state.page === 1) {
            document
              .getElementById("filter-result-app")
              .scrollTo({ top: 0, behavior: "smooth" });
          }
        })
        .finally(() => {
          const filterResultAppContainer =
            document.getElementById("filter-result-app");
          const isScrollInFilterResultAppContainer =
            filterResultAppContainer.scrollHeight >
            filterResultAppContainer.clientHeight;

          if (
            !isScrollInFilterResultAppContainer &&
            state.page + 1 <= state.total
          ) {
            dispatch("pagination", state.page);
          }
          if (state.request) {
            clearTimeout(state.request);
            state.request = null;
          }
          commit("setVehicleLoading", false);
          commit("triggerResize");
        })
    },
    async searchFilters({ commit, state, dispatch, rootState }, params) {

      if (state.refreshSearchFilter === false) {
        return;
      }

      commit("setFilterLoading", true);

      const paramsFormatted = await createFormattedParams(
        rootState,
        state,
        commit,
        dispatch,
        fieldMap,
        params,
      )

      searchFilters(paramsFormatted)
        .then((response) => {
          commit("setFilters", response.filters);
        })
        .finally(() => {
          commit("setFilterLoading", false);
        })
    },
    async getAdTypes({ state }) {
      if (state.advertiserTypes?.length > 0) return;

      await getAllAdvertiserType()
        .then(r => state.advertiserTypes = r)
        .catch(() => state.advertiserTypes = [])
    },
    async pagination({ commit }, page) {
      commit("setPage", page);
      commit("refreshSearch", true);
      commit("setRefreshSearchFilter", false);
    },
  },
};

export default filterFormModule;
